module.exports = __webpack_public_path__ + "img/ep-5-dosis.e57bc4ad.jpg";